/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from "redux";
import globalReducer from "../reducers/Login/reducer";
import homeReducer from "../reducers/Home/reducer";
import myloadReducer from "../reducers/myload/reducer";
import searchReducer from "../reducers/Search/reducer";
import carrierAssignedReducer from "../reducers/carrierAssign/reducer";
import appPageReducer from "../reducers/App/reducer";
import * as Constants from '../utils/constants';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export default function createReducer(injectedReducers = {}) {
  const appReducer = combineReducers({
    global: globalReducer,
    carrier: homeReducer,
    myload: myloadReducer,
    search: searchReducer,
    carrierAssigned: carrierAssignedReducer,
    App: appPageReducer,
    ...injectedReducers
  });
  const rootReducer = (state: any, action: any) => {
    const shouldClearRedux = action.type === Constants.LOGOUT;
    return appReducer(shouldClearRedux ? undefined : state, action);
  };
  return rootReducer;
}
